'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = Benefits;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function Benefits(_ref) {
    var _ref$benefits = _ref.benefits,
        benefits = _ref$benefits === undefined ? [] : _ref$benefits;

    return _react2['default'].createElement(
        'div',
        { className: 'seo-cloud-integrations__benefits' },
        _react2['default'].createElement(
            'h2',
            null,
            'Benefits'
        ),
        _react2['default'].createElement(
            'div',
            { className: 'row' },
            benefits.map(function (benefit) {
                return renderBenefit(benefit);
            })
        )
    );
}

function renderBenefit(_ref2) {
    var title = _ref2.title,
        icon = _ref2.icon,
        text = _ref2.text;

    return _react2['default'].createElement(
        'section',
        { key: title, className: 'large-4 columns' },
        _react2['default'].createElement(
            'div',
            { className: 'benefits-image-container' },
            _react2['default'].createElement('img', { src: icon })
        ),
        _react2['default'].createElement(
            'h3',
            null,
            title
        ),
        _react2['default'].createElement(
            'p',
            null,
            text
        )
    );
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/common/benefits-section.jsx
 ** module id = 1248
 ** module chunks = 0
 **/